<template>
  <div>
    <Loader :loading='loading' v-if='loading'/>
    <div v-else class="channels-list">
      <div class="card no-radius" 
        v-for='(channel, i) in channels'
        :key="i"
      >
        <router-link class="row no-gutters align-items-center pl-5 ml-5" 
          active-class="active"
          exact
          :to='`/live/${category || "ALL"}/${channel.channel_id}`'
        >
          <div class="col-3 col-md-2 text-right">
            <img
              :src="channel.logo" 
              class="card-img" 
            >
          </div>
          <div class="col-9 col-md-7">
            <div class="card-body">
              <p class="card-text playlist-genre mb-0">
                {{ channel.title.split(',').join(', ') }}
              </p>
              <h5 class="card-title">{{ channel.name }}</h5>
            </div>
          </div>
          <div class="col-3 d-md-none"></div>
          <div class="col-9 col-md-3 text-md-right pb-3 pb-md-0">
            <el-button
              type='success'
              class='mr-3 ml-4 ml-md-0'
            >
              <i class="live-dot"></i>
              Watch Live
            </el-button>
          </div>
          <span class="price-tag">
            {{ i }}
          </span>
        </router-link>
      </div>
      <!-- /.card -->
    </div>
  </div>
</template>

<script>
import { authRequest, log, getAppResource } from '../../../app/helpers';
import Loader from '../../../components/Loader';

export default {
  components: {
    Loader,
  },
  data: () => ({
    keyword: '',
    page: 1,
    sort: '',
    category: '',
    channels: [],
    loading: true,
    totalCount: 0,
    currentPage: null,
    perPageItem: 0,
  }),
  mounted() {
    this.setQuery();
    this.fetchChannels();
  },
  methods: {
    async fetchChannels() {
      this.loading = true;
      
      const res = await authRequest(this.$router, '/channels?page=' + this.page +
        '&search=' + encodeURI(this.keyword) + '&paginate=' + 91
         + '&sort=' + this.sort + '&category=' + this.category);

      this.channels = res.data;
      this.loading = false;
      this.totalCount = res.total
      this.currentPage = res.current_page
      this.perPageItem = parseInt(res.per_page)
    },

    search() {
      if (this.keyword == '') {
        return this.$snack.success('Please type to search');
      }

      this.$router.push({
        query: {
          keyword: this.keyword,
          page: 1
        }
      });
    },


    handleSort() {
      this.$router.push({
        query: {
          keyword: this.keyword,
          sort: this.sort,
          page: 1
        }
      });
    },

    handleSizeChange(page) {
      const { query } = this.$route;
      const params = {...query, page}
      
      this.$router.push({
        query: params
      })
    },

    setQuery() {
      const { query } = this.$route;
      let category = this.$route.params.category;
      category = category.replace('ALL', '')

      this.keyword = query.keyword || '';
      this.page = query.page || 1;
      this.sort = query.sort || '';
      this.category = category || '';
    },
  },

  watch: {
    $route() {
      this.setQuery();
      this.fetchChannels();
    },
  },
}
</script>

<style lang="scss" scoped>
.channels-list {
  .card {
    background: #151515;
    margin-bottom: 2px;

    &:hover, > a.active {
      background: #0e0e0e;
    }
    
    img {
      max-height: 50px;
      width: auto;
      max-width: 90px;
      @media (max-width: 420px) {
        max-width: 60px;
      }
    }

    .card-title {
        font-size: 22px;
        color: white;
        margin-bottom: 2px;
    }

    .card-text {
        color: white;
        font-weight: 100;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 1px;
    }

    > a:hover {
        text-decoration: none;
    }
  }
}

span.price-tag {
    font-size: 19px;
    color: #565656;
    background: #ffffff;
    margin-right: 10px;
    padding: 1px 36px;
    border-radius: 17px;
    font-weight: 800;
    left: 10px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    @media (max-width: 420px) {
      padding: 1px 16px;
    }
}

.live-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    background: #C70C13;
    border-radius: 100px;
    margin-right: 4px;
    position: relative;
    top: -1px;
}
</style>